"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLazyFetchActiveReplacementQuery = exports.useLazyFetchAreaHistoryQuery = exports.useFetchAreaHistoryQuery = exports.useReconfigureMutation = exports.areaChangeApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
// ── API Definition ──
// The backend may return the payload under either `data` or `content` depending on the route.
// Normalize at query time so the consumer always gets `data`.
exports.areaChangeApi = (0, react_1.createApi)({
    reducerPath: "areaChangeApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["AreaHistory"],
    endpoints: function (builder) { return ({
        reconfigure: builder.mutation({
            query: function (body) { return ({
                url: "/v1/area-changes/reconfigure",
                method: "POST",
                body: body,
            }); },
            transformResponse: function (raw) {
                var _a;
                return ({
                    success: raw.success,
                    message: raw.message,
                    data: ((_a = raw.data) !== null && _a !== void 0 ? _a : raw.content),
                });
            },
            invalidatesTags: ["AreaHistory"],
        }),
        fetchAreaHistory: builder.query({
            query: function (areaId) { return "/v1/area-changes/".concat(areaId, "/history"); },
            transformResponse: function (raw) {
                var _a;
                return ({
                    success: raw.success,
                    data: ((_a = raw.data) !== null && _a !== void 0 ? _a : raw.content),
                });
            },
            providesTags: ["AreaHistory"],
        }),
        fetchActiveReplacement: builder.query({
            query: function (areaId) { return "/v1/area-changes/".concat(areaId, "/active-replacement"); },
            transformResponse: function (raw) {
                var _a;
                return ({
                    success: raw.success,
                    data: ((_a = raw.data) !== null && _a !== void 0 ? _a : raw.content),
                });
            },
        }),
    }); },
});
exports.useReconfigureMutation = exports.areaChangeApi.useReconfigureMutation, exports.useFetchAreaHistoryQuery = exports.areaChangeApi.useFetchAreaHistoryQuery, exports.useLazyFetchAreaHistoryQuery = exports.areaChangeApi.useLazyFetchAreaHistoryQuery, exports.useLazyFetchActiveReplacementQuery = exports.areaChangeApi.useLazyFetchActiveReplacementQuery;
